import pluralize from 'pluralize';
import React from 'react';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import OpportunityDetails from './OpportunityDetails';

export default function BulkDelete({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Delete"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .opportunities()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={OpportunityDetails}>
      {`Are you sure you want to delete ${ids.length} ${pluralize('opportunity', ids.length)}? This action cannot be undone.`}
    </BulkActionModal>
  );
}
